import * as Yup from "yup";
import createLocalizationsSchema from "../Localizations/createLocalizationsSchema";

const ProductCategorySchema = (localeCodes) => Yup.object().shape({
  code: Yup
    .string()
    .label("ID")
    .required()
    .max(50),
  localizations: createLocalizationsSchema(localeCodes),
});

export default ProductCategorySchema;
